import { routes } from "@/consts";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Link } from "react-router-dom";
import ChangePasswordForm from "./components/change-password-form";
import { Container, Paper, Typography, Box, useTheme } from "@mui/material";

export default function ChangePasswordPage() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const theme = useTheme();
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: { xs: 4, sm: 8 },
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          p: { xs: 3, sm: 5 },
          borderRadius: 3,
          boxShadow: `0 8px 32px ${theme.palette.primary.main}11`,
          bgcolor: theme.palette.background.paper,
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h4"
            fontWeight={700}
            sx={{ mb: 1, color: theme.palette.primary.main }}
          >
            {t("authentication.changePassword.title")}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.text.secondary }}
          >
            {t("authentication.changePassword.body")}
          </Typography>
        </Box>
        <ChangePasswordForm />
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            mt: 3,
            textAlign: "center",
          }}
        >
          {t("actions.backTo")}{" "}
          <Box
            component={Link}
            to={routes.profile}
            sx={{
              color: theme.palette.secondary.main,
              textDecoration: "underline",
              fontWeight: 600,
              ml: 0.5,
              cursor: "pointer",
              "&:hover": { color: theme.palette.primary.main },
            }}
          >
            {t("profile.title")}
          </Box>
        </Typography>
      </Paper>
    </Container>
  );
}
